
export function isNativeApp() {
  return typeof window !== "undefined" && !!window.__PERSPECTIVE_NATIVE__;
}

export function getPushToken() {
  return (window && window.EXPO_PUSH_TOKEN) || "";
}

export function sendToNative(type, payload) {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ type, ...(payload || {}) }),
    );
  }
}
